<template>
  <li
    class="flex flex-nowrap items-center py-4 border-b border-gray-300 hover:bg-highlightBaseLight hover:-mx-6 hover:px-6"
    :class="{'bg-highlightBaseLight -mx-6 px-6': selected}"
    @click="toggleSelected"
  >
    <lm-checkbox :value="selected" class="mr-2" @change="toggleSelected" />
    <lm-actor-circle class="mr-3" :color="topic.color" :tooltip="actorName" />
    <lm-title class="pr-2 truncate" size="m" clickable @click="openTopic">
      {{ topic.title }}
    </lm-title>
    <lm-icon
      v-if="topic.currentUser.favorited"
      icon="star"
      size="21"
      class="ml-auto flex-shrink-0"
    />
  </li>
</template>

<script>
import LmCheckbox from '@/components/form/LmCheckbox'
import LmIcon from '@/components/ui/LmIcon'
import LmActorCircle from '@/components/ui/misc/LmActorCircle'
import LmTitle from '@/components/ui/text/LmTitle'
import {mapGetters} from 'vuex'

export default {
  name: 'TopicsSearcherItem',
  components: {LmTitle, LmActorCircle, LmIcon, LmCheckbox},
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      insightsTopics: 'insights/helpers/tempTopics',
      premisesTopics: 'premises/helpers/tempTopics'
    }),
    ...mapGetters(['getActorByID']),
    selected() {
      if (!this.section) return false
      return this[this.section + 'Topics'].includes(this.topic._id) // every time !?
    },
    section() {
      // Insights/Topics or Premises only
      const section = this.$route.name
      if (section.includes('premise')) return 'premises'
      else if (section.includes('insight') || section.includes('topics'))
        return 'insights'
      else return null
    },
    actorName() {
      return this.getActorByID(this.topic.actorId).name
    }
  },
  methods: {
    openTopic() {
      this.$router.pushQuery({topic: this.topic._id})
    },
    toggleSelected() {
      const action = this.selected ? 'removeTempTopic' : 'addTempTopic'
      this.$store.commit(`${this.section}/helpers/${action}`, this.topic._id)
    }
  }
}
</script>
